// Pure helpers for the clients feature. TSS vite/01 — utils/ has no React.

// Collapse internal whitespace and trim — preserves single spaces between words.
export function cleanName(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
}

// Trim; empty string becomes null so optional fields are sent as null,
// never as '' (the backend treats absent/null uniformly).
export function orNull(value) {
    const trimmed = (value || '').trim();
    return trimmed || null;
}
